export default __webpack_public_path__ + "static/media/Verak.2741b8cf.svg";